import ApiPermisos from './../../services/apiPermisos'

export default {
    namespaced: true,
    state: {
        loadingFD: false,
        loadingFD2: false,
        loadingAPT: false,
        loadingAPT2: false,
        error:{},
        message:{},
        tableDiagnostics:{},
        list:{},
        idNewDiagnostic:'',
        diagnostic:{},
        completeDiagnostic:{},
        tableCalifications:{},
        calification:{},
        tableAPTs:{},
        apt:{},
        tablePCLs:{},
        pcl:{},
        newDiagnosticFromOtherComponent:false,
        employeeDiseases:{}
    },
    getters: {},
    mutations: {
        setloadingFD: (state, loadingFD) => {
            state.loadingFD = loadingFD;
        },
        setLoading2: (state, loadingFD2) => {
            state.loadingFD2 = loadingFD2;
        },
        setLoadingAPT: (state, loadingAPT) => {
            state.loadingAPT = loadingAPT;
        },
        setLoadingAPT2: (state, loadingAPT2) => {
          state.loadingAPT2 = loadingAPT2;
      },
        setError:(state, error) => {
            state.error.message = error  
        },
        setMessage:(state, message) => {
            state.error = {}
            state.message = message  
        },
        setTableDiagnostics:(state, tableDiagnostics) => {
            state.tableDiagnostics = tableDiagnostics.data
        },
        setTrainigInfoById:(state, training) => {
          state.training = training
        },
        setListFormDiagnostic:(state, list) => {
            state.list = list
        },
        setIdnewDiagnostic:(state, idNewDiagnostic) => {
            state.idNewDiagnostic = idNewDiagnostic.id
        },
        setDiagnostic:(state, diagnostic) => {
            state.diagnostic = diagnostic.data
        },
        setTableCalifications:(state, tableCalifications) => {
          state.tableCalifications = tableCalifications.data
        },
        setCalification:(state, calification) => {
          state.calification = calification.data
        },
        setTableAPTs:(state, tableAPTs) => {
          state.tableAPTs = tableAPTs.data
        },
        setAPT:(state, apt) => {
          state.apt = apt.data
        },
        setTablePCLs:(state, tablePCLs) => { 
          state.tablePCLs = tablePCLs.data
        },
        setPCL:(state, pcl) => {
          state.pcl = pcl.data
        },
        setCompleteDiagnostic:(state, completeDiagnostic) => { 
          state.completeDiagnostic = completeDiagnostic.data
        },
        setNewDiagnosticFromOtherComponent:(state, newDiagnosticFromOtherComponent) => {
          state.newDiagnosticFromOtherComponent = newDiagnosticFromOtherComponent
        },
        setEmployeeDiseases:(state, employeeDiseases) => {
          state.employeeDiseases = employeeDiseases.data
        }
    },
    actions: {    

      //Trae todos los diagnosticos registrados de una persona

      actGetAllDiagnostics: async ({
        commit
      },id) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.getAllDiagnostics(id);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setTableDiagnostics', response);
          }
        } catch (error) {
          commit('setLoading2', false);
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Trae todos los diagnosticos registrados de una persona

      actGetCompleteDiagnostic: async ({
        commit
      },id) => {
        try {
          commit('setloadingFD', true);
          let response = await ApiPermisos.getCompleteDiagnostic(id);
          commit('setloadingFD', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setCompleteDiagnostic', response);
          }
        } catch (error) {
          commit('setloadingFD', false);
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Guarda un nuevo diagnosticó

      actSaveNewDiagnostic: async ({
        commit
      },data) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.saveNewDiagnostic(data);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setIdnewDiagnostic', response);
            commit('setMessage', response);
          }
        } catch (error) {
          commit('setLoading2', false);
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Trae las listas del formulario de Diagnosticos

      actGetListsForDiagnostics: async ({
        commit
      }) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.getListsForDiagnostics();
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setListFormDiagnostic', response);
          }
        } catch (error) {
          commit('setLoading2', false);
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

       //Trae un diagnostico por ID

       actGetDiagnostic: async ({ 
        commit
      },id) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.getDiagnostic(id);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setDiagnostic', response);
          }
        } catch (error) {
          commit('setLoading2', false);
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Edita un diagnóstico

      actEditDiagnostic: async ({
        commit
      },data) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.editDiagnostic(data);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setMessage', response);
          }
        } catch (error) {
          commit('setLoading2', false);
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

        //Elimina un diagnóstico

        actDeleteDiagnostic: async ({
          commit
        },data) => {
          try {
            commit('setLoading2', true);
            let response = await ApiPermisos.deleteDiagnostic(data);
            commit('setLoading2', false);
            if (response.error) {
                commit('setError', response.error.trace.message[0]);
                return response.error;
            }
            else{
              commit('setMessage', response);
            }
          } catch (error) {
            commit('setLoading2', false);
            let error2 = error.response
            commit('setError', error2.data.message);
          }
        },

      //////////////CALIFICACIÓNES  

        //Guarda una calificación 

        actSaveNewCalification: async ({
            commit
          },data) => {
            try {
              commit('setLoading2', true);
              let response = await ApiPermisos.saveNewCalification(data);
              commit('setLoading2', false);
              if (response.error) {
                  commit('setError', response.error.trace.message[0]);
                  return response.error;
              }
              else{
                commit('setMessage', response);
              }
            } catch (error) {
              commit('setLoading2', false);
              let error2 = error.response
              commit('setError', error2.data.message);
            }
          },


          //Trae todas las calificaciónes de un diagnostico

      actGetListCalification: async ({
        commit
      },id) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.getListCalifications(id);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setTableCalifications', response);
          }
        } catch (error) {
          commit('setLoading2', false);
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Trae las enfermedades

      actGetListDiseases: async ({
        commit
      },id) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.getListDiseases(id);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setEmployeeDiseases', response);
          }
        } catch (error) {
          commit('setLoading2', false);
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

          //Trae la calificación de un diagnostico

          actGetCalification: async ({
            commit
          },id) => {
            try {
              commit('setLoading2', true);
              let response = await ApiPermisos.getCalification(id);
              commit('setLoading2', false);
              if (response.error) {
                  commit('setError', response.error.trace.message[0]);
                  return response.error;
              }
              else{
                commit('setCalification', response);
              }
            } catch (error) {
              commit('setLoading2', false);
              let error2 = error.response
              commit('setError', error2.data.message);
            }
          },

          //Edita una calificación 

        actEditCalification: async ({
          commit
        },data) => {
          try {
            commit('setLoading2', true);
            let response = await ApiPermisos.editCalification(data);
            commit('setLoading2', false);
            if (response.error) {
                commit('setError', response.error.trace.message[0]);
                return response.error;
            }
            else{
              commit('setMessage', response);
            }
          } catch (error) {
            commit('setLoading2', false);
            let error2 = error.response
            commit('setError', error2.data.message);
          }
        },

         //Elimina una calificación 

         actDeleteCalification: async ({
          commit
        },id) => {
          try {
            commit('setLoading2', true);
            let response = await ApiPermisos.deleteCalification(id);
            commit('setLoading2', false);
            if (response.error) {
                commit('setError', response.error.trace.message[0]);
                return response.error;
            }
            else{
              commit('setMessage', response);
            }
          } catch (error) {
            commit('setLoading2', false);
            let error2 = error.response
            commit('setError', error2.data.message);
          }
        },

        //////////////APT  

        //Guarda un APT

        actSaveNewAPT: async ({
          commit
        },data) => {
          try {
            commit('setLoadingAPT', true);
            let response = await ApiPermisos.saveNewAPT(data);
            commit('setLoadingAPT', false);
            if (response.error) {
                commit('setError', response.error.trace.message[0]);
                return response.error;
            }
            else{
              commit('setMessage', response);
            }
          } catch (error) {
            commit('setLoadingAPT', false);
            let error2 = error.response
            commit('setError', error2.data.message);
          }
        },


        //Trae todas los APTs de un diagnostico

    actGetListAPT: async ({
      commit
    },id) => {
      try {
        commit('setLoadingAPT2', true);
        let response = await ApiPermisos.getListAPTs(id);
        commit('setLoadingAPT2', false);
        if (response.error) {
            commit('setError', response.error.trace.message[0]);
            return response.error;
        }
        else{
          commit('setTableAPTs', response);
        }
      } catch (error) {
        commit('setLoadingAPT', false);
        let error2 = error.response
        commit('setError', error2.data.message);
      }
    },

        //Trae un APT

        actGetAPT: async ({
          commit
        },id) => {
          try {
            commit('setLoadingAPT', true);
            let response = await ApiPermisos.getAPT(id);
            commit('setLoadingAPT', false);
            if (response.error) {
                commit('setError', response.error.trace.message[0]);
                return response.error;
            }
            else{
              commit('setAPT', response);
            }
          } catch (error) {
            commit('setLoadingAPT', false);
            let error2 = error.response
            commit('setError', error2.data.message);
          }
        },

        //Edita un APT

      actEditAPT: async ({
        commit
      },data) => {
        try {
          commit('setLoadingAPT', true);
          let response = await ApiPermisos.editAPT(data);
          commit('setLoadingAPT', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setMessage', response);
          }
        } catch (error) {
          commit('setLoadingAPT', false);
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

       //Elimina un APT

       actDeleteAPT: async ({
        commit
      },id) => {
        try {
          commit('setLoadingAPT', true);
          let response = await ApiPermisos.deleteAPT(id);
          commit('setLoadingAPT', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setMessage', response);
          }
        } catch (error) {
          commit('setLoadingAPT', false);
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

       //////////////PCL  

        //Guarda un PCL

        actSaveNewPCL: async ({
          commit
        },data) => {
          try {
            commit('setLoading2', true);
            let response = await ApiPermisos.saveNewPCL(data);
            commit('setLoading2', false);
            if (response.error) {
                commit('setError', response.error.trace.message[0]);
                return response.error;
            }
            else{
              commit('setMessage', response);
            }
          } catch (error) {
            commit('setLoading2', false);
            let error2 = error.response
            commit('setError', error2.data.message);
          }
        },


        //Trae todas los PCLs de un diagnostico

    actGetListPCL: async ({
      commit
    },id) => {
      try {
        commit('setLoading2', true);
        let response = await ApiPermisos.getListPCLs(id);
        commit('setLoading2', false);
        if (response.error) {
            commit('setError', response.error.trace.message[0]);
            return response.error;
        }
        else{
          commit('setTablePCLs', response);
        }
      } catch (error) {
        commit('setLoading2', false);
        let error2 = error.response
        commit('setError', error2.data.message);
      }
    },

        //Trae un PCL

        actGetPCL: async ({
          commit
        },id) => {
          try {
            commit('setLoading2', true);
            let response = await ApiPermisos.getPCL(id);
            commit('setLoading2', false);
            if (response.error) {
                commit('setError', response.error.trace.message[0]);
                return response.error;
            }
            else{
              commit('setPCL', response);
            }
          } catch (error) {
            commit('setLoading2', false);
            let error2 = error.response
            commit('setError', error2.data.message);
          }
        },

        //Edita un PCL

      actEditPCL: async ({
        commit
      },data) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.editPCL(data);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setMessage', response);
          }
        } catch (error) {
          commit('setLoading2', false);
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

       //Elimina un PCL 

       actDeletePCL: async ({
        commit
      },id) => {
        try {
          commit('setLoading2', true);
          let response = await ApiPermisos.deletePCL(id);
          commit('setLoading2', false);
          if (response.error) {
              commit('setError', response.error.trace.message[0]);
              return response.error;
          }
          else{
            commit('setMessage', response);
          }
        } catch (error) {
          commit('setLoading2', false);
          let error2 = error.response
          commit('setError', error2.data.message);
        }
      },

      //Este parametro ayuda con la creación de un nuevo diagnostico desde otro componente difernete
      //al formulario

      actNewDiagnosticFromOtherComponent:({commit},id) => {
         commit('setNewDiagnosticFromOtherComponent', id);
      },
    },
  }
  